if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });
    }

    initSlider(swiperOptions) {

      /*
      // swiperOptions.disabledOnMobile = true;
      if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
        return;
      }

      // swiperOptions.disabledOnDesktop = true;
      if (swiperOptions.disabledOnDesktop && window.innerWidth > mobileWidth) {
        return;
      }
      */

      const prevButton = this.querySelector('.announcement-bar__nav-button--prev');
      const nextButton = this.querySelector('.announcement-bar__nav-button--next');

      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1,
        resistanceRatio: 0.72,
        loop: swiperOptions.loop || false,
        allowTouchMove: true, // Always allow touch move on mobile
        autoplay: swiperOptions.autoplay || false,
        navigation: (prevButton && nextButton) ? {
          prevEl: prevButton,
          nextEl: nextButton,
        } : false,
        breakpoints: {
          1300: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 'auto',
            loop: swiperOptions.loopDesktop || swiperOptions.loop || false,
            allowTouchMove: swiperOptions.allowTouchMove !== undefined ? swiperOptions.allowTouchMove : true,
            navigation: false, // Disable navigation on desktop
          }
        }
      };

      this.slider = new Swiper(this, sliderOptions);
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
